import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { getAdsTxt as universalGetAdsTxt, updateAdsTxt as universalUpdateAdsTxt, appendAdsTxt as universalAppendAdsTxt, } from './promote-marketing-v2-ads-txt.universal';
import { WebhookIdentityType } from './promote-marketing-v2-ads-txt.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.promote.marketing.v2.ads_txt', module_name: 'wix-marketing.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        getAdsTxt: (options) => {
            const methodLogData = {
                method_name: 'getAdsTxt',
                service_name: 'com.wixpress.promote.seo.robots.server.v2.AdsServiceV2',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-marketing.v2,entity=wix.promote.marketing.v2.ads_txt,environment=velo-frontend,method-fqn=com.wixpress.promote.seo.robots.server.v2.AdsServiceV2.getAdsTxt',
            };
            return universalGetAdsTxt(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateAdsTxt: (options) => {
            const methodLogData = {
                method_name: 'updateAdsTxt',
                service_name: 'com.wixpress.promote.seo.robots.server.v2.AdsServiceV2',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-marketing.v2,entity=wix.promote.marketing.v2.ads_txt,environment=velo-frontend,method-fqn=com.wixpress.promote.seo.robots.server.v2.AdsServiceV2.updateAdsTxt',
            };
            return universalUpdateAdsTxt(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        appendAdsTxt: (options) => {
            const methodLogData = {
                method_name: 'appendAdsTxt',
                service_name: 'com.wixpress.promote.seo.robots.server.v2.AdsServiceV2',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-marketing.v2,entity=wix.promote.marketing.v2.ads_txt,environment=velo-frontend,method-fqn=com.wixpress.promote.seo.robots.server.v2.AdsServiceV2.appendAdsTxt',
            };
            return universalAppendAdsTxt(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        WebhookIdentityType,
    };
}
//# sourceMappingURL=promote-marketing-v2-ads-txt.frontend.js.map